module.exports = __webpack_public_path__ + "static/img/warning--filled.8c638ed4.svg";